import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  progressBarContainer: {
    width: '100%'
  },
  titleContent: {
    margin: '0 0 0.5em 0'
  },
  loadingMessageContent: {
    margin: '0.5em 0 0 0',
    fontSize: '1.1em'
  }
}));

const AffectedEncountersDialog = ({
  isOpen,
  affectedEncounterCount,
  contractId,
  auditType,
  itemId,
  removeAuditReasons,
  closeDialog
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <div style={{ padding: '3em' }}>
        <div style={{ textAlign: 'center' }}>
          <h3 className={classes.titleContent}>Affected Encounters</h3>
        </div>

        <div style={{ textAlign: 'center' }}>
          <span>
            Remove audit reasons for {affectedEncounterCount} encounter(s)
          </span>
        </div>

        {/* yes / no buttons */}
        <div style={{ float: 'right', marginTop: '1em' }}>
          <button
            onClick={closeDialog}
          >
            No
          </button>

          <button
            style={{ marginLeft: '0.5em' }}
            onClick={() => {
              removeAuditReasons(contractId, auditType, itemId);
            }}
          >
            Yes
          </button>
        </div>
      </div>
    </Dialog>
  );
};

AffectedEncountersDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  affectedEncounterCount: PropTypes.number.isRequired,
  contractId: PropTypes.number.isRequired,
  auditType: PropTypes.string.isRequired,
  itemId: PropTypes.number,
  closeDialog: PropTypes.func.isRequired
};

export default AffectedEncountersDialog;
